import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Plus } from "lucide-react";

const CATEGORIES = [
  "Chauffeur / limousine", "Hotel booking", "Executive security", "Restaurant reservation",
  "Yacht charter", "Helicopter transfer", "VIP event access", "Medical concierge",
  "Personal shopping", "Custom request",
];

export default function PortalConcierge() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ category: CATEGORIES[0], title: "", description: "", client_id: "temp" });

  const load = () => api.get("/concierge").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/concierge", form);
      toast.success("Concierge request submitted.");
      setOpen(false);
      setForm({ category: CATEGORIES[0], title: "", description: "", client_id: "temp" });
      load();
    } catch { toast.error("Could not submit."); }
  };

  const inp = "w-full bg-[#FAF7F0] border border-[#E5DFD2] focus:border-[#A47E2A] focus:outline-none px-4 py-3 rounded-sm text-[#1A1D24]";

  return (
    <DashboardLayout role="client">
      <div className="max-w-[1200px] mx-auto px-8 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="as-overline">Concierge</div>
            <h1 className="as-serif text-5xl font-light mt-2" data-testid="concierge-title">Bespoke services</h1>
          </div>
          <button onClick={() => setOpen(true)} className="as-btn-gold px-5 py-3 rounded-sm as-mono text-[10px] uppercase tracking-[0.2em] flex items-center gap-2" data-testid="new-concierge"><Plus size={13}/> New Request</button>
        </div>

        {open && (
          <div className="as-card p-6 mb-8" data-testid="concierge-form">
            <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label><div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Category</div>
                <select value={form.category} onChange={e => setForm({...form, category: e.target.value})} className={inp} data-testid="concierge-cat">
                  {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                </select>
              </label>
              <label><div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Title</div>
                <input required value={form.title} onChange={e => setForm({...form, title: e.target.value})} className={inp} placeholder="What you need" data-testid="concierge-title-input"/>
              </label>
              <label className="md:col-span-2"><div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Details</div>
                <textarea rows="4" value={form.description} onChange={e => setForm({...form, description: e.target.value})} className={inp} data-testid="concierge-desc"/>
              </label>
              <div className="md:col-span-2 flex gap-3 justify-end">
                <button type="button" onClick={() => setOpen(false)} className="as-btn-ghost px-4 py-2.5 rounded-sm as-mono text-[10px] uppercase tracking-widest">Cancel</button>
                <button className="as-btn-gold px-5 py-2.5 rounded-sm as-mono text-[10px] uppercase tracking-widest" data-testid="concierge-submit">Submit</button>
              </div>
            </form>
          </div>
        )}

        <div className="as-card divide-y divide-[#E5DFD2]" data-testid="concierge-list">
          {items.length === 0 && <div className="p-10 text-center text-[#756E64]">No concierge requests yet.</div>}
          {items.map(c => (
            <div key={c.id} className="p-5 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-sm bg-[#A47E2A]/10 flex items-center justify-center"><Sparkles size={16} className="as-gold"/></div>
                <div>
                  <div className="text-[#1A1D24]">{c.title}</div>
                  <div className="as-mono text-[10px] text-[#756E64] uppercase tracking-widest mt-0.5">{c.category}</div>
                  {c.description && <div className="text-xs text-[#756E64] mt-1 max-w-xl">{c.description}</div>}
                </div>
              </div>
              <div className={`as-pill ${c.status === "Confirmed" ? "as-pill-green" : c.status === "New" ? "as-pill-muted" : c.status === "Completed" ? "as-pill-green" : "as-pill-orange"}`}>{c.status}</div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
